(function($){
  var theme = window.theme || {};

  theme.mobileNavigation ={
    init: function(){
      //$('.menu-dropdown-toggle').on('click', this.menuToggle);
      $('.menu-dropdown-box-toggle').on('click', this.menuToggleBox);
       $('.site-nav__close-button').on('click', this.closeDrawer);
       $('.burger-menu').on('click', this.burgerMenuAction);
    },

   menuToggle: function(e){
     e.preventDefault();
     $(this).parent().toggleClass('open');
   },

   menuToggleBox: function(e){
    e.preventDefault();
    $(this).parent().toggleClass('open');
  },

  closeDrawer: function(e){
    e.preventDefault();
    $('.site-nav__container').animate({
      'width': '1px'
    }, 100, function(){
      $('.site-nav__container').hide();
    });
  },
   
   burgerMenuAction: function(e){
      e.preventDefault();
      $('.site-nav__container').show().animate({
          'width': '310px'
      }, 100);

      if ( $(this).hasClass('site-nav__close-button')) {
        $('body').removeClass('drawer--open');
      } else {
        $('body').addClass('drawer--open');
      }
    }
  };
  $(document).ready(function(){
    theme.mobileNavigation.init();
  });

  const headerSection = document.querySelector("#main-header");

  window.onscroll = () => {
    if ( window.pageYOffset > headerSection.offsetTop) {
      headerSection.classList.add('sticky-header');
    } else {
      headerSection.classList.remove('sticky-header');
    }
  }

})(jQuery);